import React, {useCallback, useEffect} from "react";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import {withStyles} from "@material-ui/styles";
import AddButton from "../../../../../../../../ui/AddButton";
import AddVariantModal from "../AddVariantModal";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

const styles = () => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  }
});

const defaultData = {
  deleteModalOpen: false,
  addModalOpen: false,
};

export const QuestionVariantsList = ({getVariantList, variants,
                                       questionId, classes,
                                       createVariant, deleteVariant,
                                       createdVariant, setCreatedVariant}) => {
  const [data, setData] = React.useState(defaultData);
  const {deleteModalOpen, addModalOpen} = data;

  useEffect(() => {
    getVariantList(questionId);
  }, []);

  const createVariantChain = useCallback((form) => {
    return createVariant(questionId, form)
      .then(() => {
        getVariantList(questionId);
      }, () => {
        setCreatedVariant(null);
        setData({...data, addModalOpen:false});
      })
  }, [data, createVariant, setData]);

  const deleteVariantChain = useCallback((variantId) => {
    return deleteVariant(variantId)
      .then(() => {
        //setData({deleteModalOpen:false});
        getVariantList(questionId);
      }, () => {
        //setData({deleteModalOpen:false});
      })
  }, [data, deleteVariant, setData]);

  return (<div className={classes.root}>
      <AddVariantModal title="Добавить вариант"
                       confirmButtonCaption="Сохранить"
                       open={addModalOpen}
                       handleClose={() => {
                         setData({...data, addModalOpen:false});
                       }}
                       onCreate={(formData) => createVariantChain(formData)}
                       createdObject={createdVariant}/>
      <div className={classes.heading}>
        Варианты ответа
        <div style={{"marginLeft":16}}>
          <AddButton onClick={() => {
            setCreatedVariant(null);
            setData({...data, addModalOpen:true})
          }}/>
        </div>
      </div>
      <List dense={false}>
      {variants && variants.map((variant,idx) =><div key={`variant-question-${questionId}-${idx}`}><ListItem>
          <ListItemText primary={`#${variant.order}. ${variant.description}`}/>
          <ListItemSecondaryAction>
            <IconButton onClick={() => deleteVariantChain(variant.id)} edge="end" aria-label="delete">
              <DeleteForeverOutlinedIcon/>
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem><Divider/></div>)}
    </List>
  </div>)
}

export default withStyles(styles)(QuestionVariantsList);
